export const languages = {
    EN: 'en_EN',
    DE: 'de_DE',
    TR: 'tr_TR'
}
